//import _ from 'lodash'
//import mattressLogic from './mattressLogic'
//import $ from './jquery';
import 'nouislider/dist/nouislider.css';

import Swiper from 'swiper';
import SwiperCore, {Navigation, Pagination} from 'swiper/core';

SwiperCore.use([Navigation, Pagination]);

export default {

  init() {
    this.swiperimg();
    this.swiperfeatures();
  },

  swiperimg() {
    if ($('.mySwiper').length) {
      const swiper = new Swiper('.mySwiper', {
        direction: 'horizontal',
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }
  },
  swiperfeatures() {
    const $features = $('.features');
    
    $features.each(function () {
      const swiper = new Swiper(this, {
        direction: 'horizontal',
        draggable: true,
        slidesPerView: 1,
        navigation: {
          nextEl: this.parentNode.querySelector('.swiper-button-next'),
          prevEl: this.parentNode.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          1400: {
            slidesPerView: 4,
          },
          768: {
            slidesPerView: 2,
          },
        },
      });
    });
  },
};